import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

type DeleteConfirmationModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onDelete: () => void;
};

export const DeleteConfirmationModal = (props: DeleteConfirmationModalProps) => {
  const { isOpen, onCancel, onDelete } = props;

  return (
    <>
      <Modal open={isOpen} onClose={onCancel} size="small">
        <Modal.Header>Delete Confirmation</Modal.Header>
        <Modal.Content>
          <p>Are you sure you want to permenantly delete this file?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onCancel}>Cancel</Button>
          <Button color="red" onClick={onDelete}>
            Delete
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
